
export const evinaConfig = {
    evinaClientId: '3f5fbd11-70e3-44d6-b2ec-cd1a1302885c',
    evinaClientSecret: 'tVIXRGvvpub9QFKhNpw9KcULHNdWO7Oy',
};

export const campaignConfig = {
    host: `https://campaign-hub.penroseza.com`,
}

export const dcbConfig = {
    host: `https://vodacom-za.migration.penroseza.co.za`
}

export const ethiotelConfig = {
    host: `https://onevas.migration.penroseza.co.za`,
    redirectUrl: 'http://196.189.186.87:8889/consent-gateway/suboptin',
    username: '300049',
    password: 'Sta#6640',
}

export const fantasyConfig = {
    pricePoint: 20,
    offerCode: '001050038026'
}

export const blgConfig = {
    pricePoint: 20,
    offerCode: '001050038012'
}